<app-header></app-header>

<section class="container-xxl">
  <!-- BREADCRUMB AREA - STARTS -->
  <div class="breadcrumb-area">
    <nav aria-label="breadcrumb mb-0"> 
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Home':'होम'" routerLink="/">{{"Home"|translate}}</a></li>
        <li class="breadcrumb-item"><a class="screen-reader" [attr.title]="language=='English'?'Awards':'पुरस्कार'" routerLink="/award">{{"Awards"|translate}}</a></li>
        <li class="breadcrumb-item active screen-reader">{{"AwardDeatil"|translate}}</li>
      </ol>
    </nav>
  </div>
  <!-- BREADCRUMB AREA - ENDS -->
  <div id="section-New"></div>

  <div class="inner-page">
    <div class="inner-page-details">
      <div class="row">
        <div class="col-lg-12">
          <!-- INNER CONTENT - STARTS -->
          <div class="inner-page-sidedetails">
            <div class="row">
              <div class="col-lg-12">
                <div class="description">
                  <div class="awards">
                    <div class="row">
                      <div class="col-lg-12">
                        <!-- awards section area -->
                        <div class="events-section">
                          <div class="card mb-4">
                            <div class="card-body">
                              <div class="text-highlight text-center">
                                <h2 class="screen-reader">{{'TheAwardees-' | translate}} <br /><span>{{'-Photo' | translate}}</span></h2>
                              </div>
                              <div class="col-md-12 col-xl-12 ps-xxl-0 pe-xxl-0 ps-xl-0 pe-xl-0 ps-lg-0 pe-lg-0">
                                <div class="row">
                                  <div class="col-xxl-8 col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 mx-auto">
                                    <div class="event-image">
                                      <div class="sm-txt screen-reader">
                                        {{'MomentOfTheDay' | translate}}
                                      </div>
                                      <img *ngIf="awardList[0]?.featuredImage_details.fileSize!==''"
                                        [src]="this.imageUrl+awardList[0]?.featuredImage" alt="FCI - Event Image"
                                        class="img-fluid img-fit" />
                                      <div class="content-details fadeIn-top">
                                      </div>
                                    </div>
                                    <div class="multi-color-border"></div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xxl-8 col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 mx-auto">
                                    <div class="row">
                                      <div class="col-xxl-4 col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12 mt-3">
                                        <div class="sm-txt-2 screen-reader font-adjust">
                                          <span>{{'Congratulations' | translate}}</span>
                                          <h2>{{'Awardees' | translate}}</h2>
                                        </div>
                                      </div>
                                      <div class="col-xxl-8 col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div class="event-headers font-40 font-adjust ">
                                          <h4 class="screen-reader">
                                            {{htmldecode(language == 'English' ? awardList[0]?.title: awardList[0]?.titleInHindi)}}
                                          </h4>
                                          <p class="screen-reader">
                                            {{htmldecode(language == 'English' ? awardList[0]?.snippet: awardList[0]?.snippetInHindi)}}
                                          </p>

                                          <div class="d-flex mt-3 align-items-center">
                                            <div class="clock">
                                              <i class="bi bi-calendar"></i>
                                            </div>
                                            <div class="event-time font-adjust ">
                                              <p class="text-time screen-reader">
                                                {{awardList[0]?.fromDate |
                                                date}} - {{awardList[0]?.toDate
                                                | date}}
                                              </p>
                                            </div>
                                          </div>
                                          <div class="d-flex mt-3 align-items-center">
                                            <div class="clock">
                                              <i class="bi bi-geo-alt"></i>
                                            </div>
                                            <div class="event-time">
                                              <p class="text-time screen-reader font-adjust ">
                                                {{htmldecode(language == 'English' ? awardList[0]?.location: awardList[0]?.locationInHindi)}}
                                              </p>
                                              <p></p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="brd">
                                  <hr />
                                </div>
                                
                                <div class="event-desc font-adjust">
                                  <h5 class="screen-reader">{{'Description' | translate}}</h5>
                                  <p class="screen-reader" [innerHTML]="htmldecode(language == 'English' ? awardList[0]?.description: awardList[0]?.descriptionInHindi)"></p>
                                </div>

                                <div class="brd">
                                  <hr />
                                </div>

                                <div class="event-gal">
                                  <h5 class="screen-reader">{{'Gallery' | translate}}</h5>
                                  <div class="row">

                                    <!-- AWARDEES SLIDER SECTION - STARTS -->

                                    <section class="awardees-list">
                                      <div class="position-relative container-xxl">
                                        <div class="swiper" id="awardees-swiper">
                                          <div class="swiper-wrapper" id="award-container">
                                            <div class="swiper-slide"
                                              [attr.data-responsive]="backend_url+'storage/app/uploads/'+item.images"
                                              [attr.data-src]="backend_url+'storage/app/uploads/'+item.images"
                                              *ngFor="let item of galleryImg; let x = index;">
                                              <div class="item-img">
                                                <a class="d-md-flex justify-content-md-center" [attr.title]="language=='English'?'View Photo':'फ़ोटो देखें'">
                                                  <div class="item-img">
                                                    <img [alt]="item.shortTitle" class="card-img-top" alt="FCI - Event Image"
                                                      [src]="backend_url+'storage/app/uploads/'+item.images" />
                                                  </div>
                                                  <div class="play-btn-container">
                                                    <span class="play-btn">
                                                      <i class="bi bi-zoom-in"></i>
                                                    </span>
                                                  </div>
                                                </a>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="swiper-button-prev award-prev"></div>
                                        <div class="swiper-button-next award-next"></div>
                                      </div>
                                    </section>
                                    <!-- AWARDEES SLIDER SECTION - ENDS -->

                                </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- awards section area -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- INNER CONTENT - ENDS -->
        </div>
      </div>
    </div>
  </div>
</section>

<app-clients></app-clients>

<app-footer></app-footer>